import React from "react";

function BackgroundElements() {
  return (
    <div className="absolute top-0 right-0 w-6/12 h-full z-0 max-md:relative max-md:mt-10 max-md:w-full max-md:h-auto max-sm:-right-5">
      {/* Background Lines SVG */}
      <div>
        <img 
        src=".\image\design-b3dcb2a2-23f6-41f0-b740-595184e6d3e9 1.png" 
        alt=""
        className="absolute top-0 right-32 w-[501px] h-[707px] z-10 max-sm:w-[300px] max-sm::h-[500px] max-sm:hidden"
        />
      </div>
      <div>
        <svg
          width="997"
          height="794"
          viewBox="0 0 997 794"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="absolute right-0 top-0 w-[1000px] h-[794px] max-sm:-top-[440px] max-sm:w-[800px]"
        >
          <path
            opacity="0.6"
            d="M328.972 194.827L615.806 54.9799L617.987 263.252L329.227 402.94L328.972 194.827Z"
            stroke="#CCCCF5"
            strokeWidth="4"
          ></path>
          <path
            opacity="0.7"
            d="M428.972 304.383L997.883 24.3027L1120.59 325.287L429.229 662.488L428.972 304.383Z"
            stroke="#CCCCF5"
            strokeWidth="4"
          ></path>
          <path
            opacity="0.7"
            d="M261.005 527.224L816.767 243.268L816.767 583.273L261.229 865.43L261.005 527.224Z"
            stroke="#CCCCF5"
            strokeWidth="4"
          ></path>
          <path
            opacity="0.7"
            d="M2.00481 874.244L517.767 620.214L517.767 930.252L2.22902 1182.48L2.00481 874.244Z"
            stroke="#CCCCF5"
            strokeWidth="4"
          ></path>
        </svg>
      </div>
    </div>
  );
}

export default BackgroundElements;
